import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import InfoPrompt from '../../../InfoPrompt/InfoPrompt';

import {
  TXTWCL_Unique_ID,
  TXTWCL_You_will_need_to_reference_thi_ELL,
  TXTWCL_Your_unique_ID_isX_0N
} from './RMFUniqueIdPrompt.messages.json';
import { jurneyFootnotes, mainContent } from './RMFUniqueIdPrompt.scss';

const UniqueIdPrompt = () => {
  const isDE = useSelector(select.cms.getSiteId) === Sites.DE;
  const userIntId = useSelector(select.account.getUserIntId);

  return isDE ? (
    <div className={jurneyFootnotes}>
      <Translation tagName="span" {...TXTWCL_Unique_ID} />: {userIntId}
      <span className="infoIcon">
        <InfoPrompt title={{ translation: TXTWCL_Unique_ID }} variant="rmf">
          <div className={mainContent}>
            <Translation
              tagName="span"
              {...TXTWCL_Your_unique_ID_isX_0N}
              values={{
                0: <b> {userIntId} </b>
              }}
            />
            <Translation tagName="div" {...TXTWCL_You_will_need_to_reference_thi_ELL} />
          </div>
        </InfoPrompt>
      </span>
    </div>
  ) : null;
};

export default UniqueIdPrompt;
